module.exports = __webpack_public_path__ + "lato-semibold-italic-9fcec04cdba9253e002e740a7cd743fe.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-semibold-italic/lato-semibold-italic.woff
// module id = 1057
// module chunks = 0